module.exports = __webpack_public_path__ + "img/TWD.fb873df3.svg";